import ContractAttachments from './ContractAttachments';

export default ContractAttachments;
